import { useMemo } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { useLdReady } from '@omnea-app/fe-org-settings/useLdReady'
import { useRouteLdFlags } from './launch-darkly'
import type { AvailabilityInputs } from './availability'

/** The sources every route's availability rule is resolved against. */
export const useAvailabilityInputs = (): AvailabilityInputs => {
  const orgFlags = useFeatureFlags()
  const isLdReady = useLdReady()
  const ldFlags = useRouteLdFlags()
  const { isOmnean } = useAuthenticatedUser().user

  return useMemo(() => ({ orgFlags, isLdReady, ldFlags, isOmnean }), [orgFlags, isLdReady, ldFlags, isOmnean])
}
